// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text, Graphics } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'bf47187e-5dfa-4fba-a5ee-eb1c844f9493',
      type: 'Container',
      name: 'partContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '115f959f-044c-4281-9ef3-7ab7c6d801f6',
      type: 'Container',
      name: 'wrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'c5a6cd64-4a1c-4e85-9f12-69545bcd9bbc',
      type: 'Sprite',
      name: 'rays',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16245612,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '115f959f-044c-4281-9ef3-7ab7c6d801f6'
    },
    {
      id: '931e7962-9758-485b-b351-5fbbf8925438',
      type: 'Sprite',
      name: 'circleGlow',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16245612,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: '115f959f-044c-4281-9ef3-7ab7c6d801f6'
    },
    {
      id: 'fcccce0c-3d00-4a2a-be4a-aab97b20152d',
      type: 'Sprite',
      name: 'rewardIcon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.5,
        y: 1.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Goal_Icon',
      parent: '115f959f-044c-4281-9ef3-7ab7c6d801f6',
      stateByName: {
        coin: {
          texture: 'Big_Coin_Icon'
        },
        piggyBank: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Normal',
          scale: {
            x: 1,
            y: 1
          },
          visible: false
        },
        piggyBankFull: {
          texture: 'Piggy_Bank_Main_Menu_Icon_Sorry',
          scale: {
            x: 1,
            y: 1
          },
          visible: false
        }
      }
    },
    {
      id: 'cf5c8e5a-c0f6-4e04-9051-5aed26adaf8b',
      type: 'Container',
      name: 'piggyBankSlot',
      className: '',
      x: 20,
      y: -26,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '115f959f-044c-4281-9ef3-7ab7c6d801f6',
      stateByName: {
        piggyBank: {
          visible: true
        },
        piggyBankFull: {
          visible: true
        }
      }
    },
    {
      id: '735d3a95-a799-4675-8ab1-2e590acc1468',
      type: 'Text',
      name: 'rewardAmountText',
      className: '',
      x: 0,
      y: 100,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xXX',
      localize: false,
      maxWidth: 300,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x450702',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '115f959f-044c-4281-9ef3-7ab7c6d801f6'
    },
    {
      id: '9939add3-d2d5-4232-8644-ecfe1c0e401d',
      type: 'Container',
      name: 'piggyBankContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '115f959f-044c-4281-9ef3-7ab7c6d801f6'
    },
    {
      id: '639145d8-97f9-4199-b016-def58cbc4e5d',
      type: 'Container',
      name: 'particleStartPoint',
      className: '',
      x: 0,
      y: -54,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '115f959f-044c-4281-9ef3-7ab7c6d801f6'
    },
    {
      id: '5b629907-01e8-4f74-b429-c0317876bc9d',
      type: 'Container',
      name: 'oldAmountContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '115f959f-044c-4281-9ef3-7ab7c6d801f6'
    },
    {
      id: 'a7a7a462-0710-4201-be70-a32fef86e2cd',
      type: 'Text',
      name: 'fullText',
      className: 'upperCase_SPL',
      x: 0,
      y: 100,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Full',
      localize: true,
      maxWidth: 300,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'yellow',
        stroke: '0x77322E',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9939add3-d2d5-4232-8644-ecfe1c0e401d'
    },
    {
      id: '785a9a40-35f5-488a-ae07-64c6d257ab7c',
      type: 'Sprite',
      name: 'impact',
      className: '',
      x: 0,
      y: -84,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Piggy_Bank_Impact_Effect',
      parent: '9939add3-d2d5-4232-8644-ecfe1c0e401d'
    },
    {
      id: '0c8287d2-769f-4fa4-abb4-07e9ba689e19',
      type: 'Sprite',
      name: 'piggyCoin',
      className: '',
      x: 0,
      y: -117,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Piggy_Bank_Small_Coin_Animation',
      parent: '9939add3-d2d5-4232-8644-ecfe1c0e401d'
    },
    {
      id: 'fa52cda0-23c3-4117-8b4e-71c4a6a6366e',
      type: 'Text',
      name: 'oldRewardAmountText',
      className: '',
      x: 0,
      y: 100,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xXX',
      localize: false,
      maxWidth: 300,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x450702',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '5b629907-01e8-4f74-b429-c0317876bc9d'
    },
    {
      id: '558eb870-e0d4-4f97-8a1e-9bf4b5dd523e',
      type: 'Graphics',
      name: 'oldRewardCrossed',
      className: '',
      x: 0,
      y: 100,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: -4,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5b629907-01e8-4f74-b429-c0317876bc9d',
      commands: [
        {
          id: '2ae094ad-554b-4851-b5b6-b2f80ccce3a3',
          type: 'beginFill',
          color: 16711680,
          alpha: 1
        },
        {
          id: 'ad3eba02-145f-473b-9d1e-926ad29227c7',
          type: 'drawRoundedRect',
          x: -50,
          y: 0,
          width: 100,
          height: 6,
          radius: 3
        },
        {
          id: '25f93bb5-ca4c-4ecb-bc89-5b3951f99f44',
          type: 'beginFill',
          color: 16711680,
          alpha: 1
        }
      ]
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'coin',
    'piggyBank',
    'piggyBankFull'
  ],
  animations: [
    {
      id: '136ac105-b59c-4bb8-a6aa-c5bc0e57d484',
      name: 'Rewards_Animation',
      playingSpeed: 1,
      totalDuration: 10000,
      blocks: [
        {
          id: '8f1c0229-7a16-47cf-ad8e-401622669137',
          type: 'Setter',
          name: 'ResetAngle',
          track: 1,
          target: {
            angle: 0
          },
          startAt: 0,
          sourceName: 'rays',
          disabled: false
        },
        {
          id: '5f47a946-f554-4521-b9e8-e9a6b4132132',
          type: 'Tween',
          name: 'raysRotation',
          duration: 10000,
          track: 2,
          target: {
            angle: 360
          },
          startAt: 0,
          sourceName: 'rays',
          easing: 'Linear',
          disabled: false
        }
      ]
    },
    {
      id: '6d86ad05-c3ee-4900-8d12-bca56f7b2883',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 400,
      blocks: [
        {
          id: '217a91e0-0331-46b0-bad0-c605d71f1f2c',
          type: 'Setter',
          name: 'FXPART_End_Game_Behind_Rewards_Particles',
          track: 1,
          target: {},
          startAt: 0,
          sourceName: 'partContainer',
          disabled: false
        },
        {
          id: 'b387f7a2-0971-4368-b644-e0d25f477191',
          type: 'Setter',
          name: 'Wrapper',
          track: 2,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'wrapper',
          disabled: false
        },
        {
          id: '7254413a-7f4c-4213-baf1-5d172e072f31',
          type: 'Tween',
          name: 'WrapperScale',
          duration: 400,
          track: 3,
          target: {
            scale: {
              y: 1,
              x: 1
            }
          },
          startAt: 1,
          sourceName: 'wrapper',
          easing: 'CubicOut',
          disabled: false
        }
      ]
    },
    {
      id: 'de65031e-4477-42a2-bdf8-dfb01017c142',
      name: 'Show_Old_Amount',
      playingSpeed: 1,
      totalDuration: 4000,
      blocks: [
        {
          id: '26ee50b0-667e-4d1c-a649-d50671373948',
          type: 'Setter',
          name: 'containerAlphaSetter',
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'oldAmountContainer',
          disabled: false
        },
        {
          id: '9b7bcaa3-68f7-477b-b7c3-b993852c9399',
          type: 'Tween',
          name: 'crossedFade',
          duration: 300,
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'oldRewardCrossed',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'a9eed676-921d-4cbb-b84d-c3d3a3a7de3c',
          type: 'Tween',
          name: 'containerMoveAndFade',
          duration: 300,
          track: 4,
          target: {
            y: 50,
            alpha: 0.7,
            scale: {}
          },
          startAt: 0,
          sourceName: 'oldAmountContainer',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'f1054926-049c-45f7-be9e-c4c8872dc099',
          type: 'Tween',
          name: 'increaseAmountSize',
          duration: 300,
          track: 5,
          target: {
            scale: {
              x: 1.2,
              y: 1.2
            }
          },
          startAt: 0,
          sourceName: 'rewardAmountText',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'f6a5e21d-1af4-4e3c-9a27-ed0a50e2ec88',
          type: 'Tween',
          name: 'containerMoveFadeOut',
          duration: 2000,
          track: 3,
          target: {
            alpha: 0,
            scale: {}
          },
          startAt: 1999,
          sourceName: 'oldAmountContainer',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    },
    {
      id: '3f4dc53e-1841-4cc0-ab3d-546a46592a0b',
      name: 'PiggyBank_Full',
      playingSpeed: 1,
      totalDuration: 3000,
      blocks: [
        {
          id: 'a2db2784-5113-4416-b15f-f1d467981d39',
          type: 'Tween',
          name: 'rewardText_scaleTween_1',
          duration: 50,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: -2,
          sourceName: 'rewardAmountText',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '3b53a563-b384-4915-83b3-1ebd4ebc897d',
          type: 'Tween',
          name: 'rewardText_scaleTween_0',
          duration: 125,
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 48,
          sourceName: 'rewardAmountText',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '820e59a3-7f83-4bf3-a85c-5d083fe934b1',
          type: 'Tween',
          name: 'fullText_scaleTween_0',
          duration: 125,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 173,
          sourceName: 'fullText',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '7aad2396-ba2f-427c-907f-fa57f22d9119',
          type: 'Tween',
          name: 'fullText_pos_Tween_0',
          duration: 50,
          track: 3,
          target: {
            x: -5
          },
          startAt: 279,
          sourceName: 'fullText',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'b19ac1b0-61ed-41bf-8d41-43b702f17294',
          type: 'Tween',
          name: 'fullText_pos_Tween_1',
          duration: 100,
          track: 3,
          target: {
            x: 5
          },
          startAt: 329,
          sourceName: 'fullText',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '96c22d00-4ed4-494c-8f34-995be026e2ea',
          type: 'Setter',
          name: 'piggyCoin_setAlpha',
          track: 4,
          target: {
            alpha: 1
          },
          startAt: 344,
          sourceName: 'piggyCoin',
          disabled: false
        },
        {
          id: 'fe0e993e-4bea-4944-bd4a-61f359b70313',
          type: 'Tween',
          name: 'piggyCoin_tweenPos_0',
          duration: 170,
          track: 5,
          target: {
            y: -60
          },
          startAt: 355,
          sourceName: 'piggyCoin',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '0d754682-d058-4e51-bd0e-f0da6d860cb6',
          type: 'Tween',
          name: 'fullText_pos_Tween_2',
          duration: 100,
          track: 3,
          target: {
            x: -5
          },
          startAt: 429,
          sourceName: 'fullText',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'a068fae5-9fde-46df-8464-a1e601683b89',
          type: 'Tween',
          name: 'piggyCoin_tweenScale_0',
          duration: 75,
          track: 11,
          target: {
            scale: {
              x: 1.1,
              y: 0.8
            }
          },
          startAt: 446,
          sourceName: 'piggyCoin',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '783ce863-3305-4c05-b38c-9872a08e97ae',
          type: 'Tween',
          name: 'rewardIcon_tweenScale_0',
          duration: 75,
          track: 13,
          target: {
            scale: {
              x: 1.06,
              y: 0.96
            }
          },
          startAt: 450.3333435058594,
          sourceName: 'rewardIcon',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'b2953a34-3604-4986-8716-f44da88e5ded',
          type: 'Tween',
          name: 'impact_alphaTween_0',
          duration: 50,
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 519,
          sourceName: 'impact',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '728695af-fa33-4736-8f9c-91236328a5bb',
          type: 'Tween',
          name: 'rewardIcon_tweenScale_1',
          duration: 75,
          track: 13,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 521,
          sourceName: 'rewardIcon',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '1bcf0ffd-d767-422a-8118-19cb15167a29',
          type: 'Tween',
          name: 'piggyCoin_tweenScale_1',
          duration: 75,
          track: 11,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 521,
          sourceName: 'piggyCoin',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '8b742d9b-e4b6-4e64-9907-45c6c9fd2aee',
          type: 'Setter',
          name: 'impact_setAlpha_0',
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 522,
          sourceName: 'impact',
          disabled: false
        },
        {
          id: 'ad7bc1d3-312f-47d6-a70d-e7c6d536bf38',
          type: 'Tween',
          name: 'piggyCoin_tweenPos_1',
          duration: 220,
          track: 5,
          target: {
            y: -105
          },
          startAt: 525,
          sourceName: 'piggyCoin',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '450758da-3d44-484f-a491-710f42e17c17',
          type: 'Tween',
          name: 'fullText_pos_Tween_3',
          duration: 100,
          track: 3,
          target: {
            x: 5
          },
          startAt: 529,
          sourceName: 'fullText',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '08cefae9-335e-4e38-bf80-a5ca0f8e6247',
          type: 'Tween',
          name: 'fullText_pos_Tween_4',
          duration: 100,
          track: 3,
          target: {
            x: -5
          },
          startAt: 629,
          sourceName: 'fullText',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '641c3639-ac3a-4e74-b07c-80f3d83ef497',
          type: 'Tween',
          name: 'piggyCoin_tweenPos_2',
          duration: 220,
          track: 5,
          target: {
            y: -60
          },
          startAt: 735,
          sourceName: 'piggyCoin',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: 'b279204d-e21f-408b-81fe-d4621a94a956',
          type: 'Tween',
          name: 'piggyCoin_tweenScale_0_copy',
          duration: 75,
          track: 11,
          target: {
            scale: {
              x: 1.1,
              y: 0.8
            }
          },
          startAt: 874,
          sourceName: 'piggyCoin',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '3731d59b-aae0-4214-b440-a19f2488d0e6',
          type: 'Tween',
          name: 'rewardIcon_tweenScale_0_copy',
          duration: 75,
          track: 13,
          target: {
            scale: {
              x: 1.06,
              y: 0.96
            }
          },
          startAt: 876,
          sourceName: 'rewardIcon',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'bf8eb7fd-371f-445c-8b5e-80d59f7752bf',
          type: 'Tween',
          name: 'piggyCoin_tweenScale_1_copy',
          duration: 75,
          track: 11,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 949,
          sourceName: 'piggyCoin',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '6e63bbb5-ddaf-4e38-a1db-f5b05e0f79c7',
          type: 'Tween',
          name: 'rewardIcon_tweenScale_1_copy',
          duration: 75,
          track: 13,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 951,
          sourceName: 'rewardIcon',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'c47d2b0e-8274-443f-a3aa-fa8d500e0eeb',
          type: 'Tween',
          name: 'impact_alphaTween_1',
          duration: 50,
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 951,
          sourceName: 'impact',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '42f56a28-f6b0-446a-8d2f-398ebde5f4ef',
          type: 'Setter',
          name: 'impact_setAlpha_1',
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 953,
          sourceName: 'impact',
          disabled: false
        },
        {
          id: '2d633add-fc6b-4fb9-a37f-3a0967a411e3',
          type: 'Tween',
          name: 'piggyCoin_tweenPos_3',
          duration: 250,
          track: 5,
          target: {
            y: -120
          },
          startAt: 955,
          sourceName: 'piggyCoin',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '2df9b5a1-17ea-43b1-b7b3-5c616f4f8f19',
          type: 'Tween',
          name: 'piggyCoin_tweenPos_4',
          duration: 220,
          track: 5,
          target: {
            y: -60
          },
          startAt: 1205,
          sourceName: 'piggyCoin',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: '5bec4485-c505-461f-bca5-a370541a245f',
          type: 'Tween',
          name: 'piggyCoin_tweenScale_0_copy_copy',
          duration: 75,
          track: 11,
          target: {
            scale: {
              x: 1.1,
              y: 0.8
            }
          },
          startAt: 1345,
          sourceName: 'piggyCoin',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '7ad4093a-877e-4025-a37b-4866593bc5fb',
          type: 'Tween',
          name: 'rewardIcon_tweenScale_0_copy_copy',
          duration: 75,
          track: 13,
          target: {
            scale: {
              x: 1.06,
              y: 0.96
            }
          },
          startAt: 1346,
          sourceName: 'rewardIcon',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '0c2a217e-0ce9-4e0b-8100-0d993ef53139',
          type: 'Tween',
          name: 'piggyCoin_tweenScale_1_copy_copy',
          duration: 75,
          track: 11,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1420,
          sourceName: 'piggyCoin',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'ac3c81dc-1ebd-4a0d-ac1f-b853c828fad7',
          type: 'Tween',
          name: 'rewardIcon_tweenScale_1_copy_copy',
          duration: 75,
          track: 13,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1421,
          sourceName: 'rewardIcon',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'f4891f7a-5c7f-487c-9446-496b3dc6e850',
          type: 'Tween',
          name: 'impact_alphaTween_2',
          duration: 50,
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 1421,
          sourceName: 'impact',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '00bfd51a-8967-47ee-b258-8cbd36d9269e',
          type: 'Setter',
          name: 'impact_setAlpha_2',
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 1422,
          sourceName: 'impact',
          disabled: false
        },
        {
          id: 'e3f8f52b-2d47-4a6e-8f25-db04db9c1aef',
          type: 'Tween',
          name: 'piggyCoin_tweenPos_5',
          duration: 220,
          track: 5,
          target: {
            y: -105
          },
          startAt: 1425,
          sourceName: 'piggyCoin',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '54bedee9-2c35-4344-bd2a-2b6f7c3c6a2a',
          type: 'Tween',
          name: 'piggyCoin_tweenPos_6',
          duration: 220,
          track: 5,
          target: {
            y: -60
          },
          startAt: 1645,
          sourceName: 'piggyCoin',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: '4d93a51e-2423-4936-a8d4-926b4cab9d6f',
          type: 'Tween',
          name: 'rewardIcon_tweenScale_0_copy_copy_copy',
          duration: 75,
          track: 13,
          target: {
            scale: {
              x: 1.06,
              y: 0.96
            }
          },
          startAt: 1787,
          sourceName: 'rewardIcon',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'c08975e3-de29-48b7-bd4e-4087d91d8fde',
          type: 'Tween',
          name: 'piggyCoin_tweenScale_0_copy_copy_copy',
          duration: 75,
          track: 11,
          target: {
            scale: {
              x: 1.1,
              y: 0.8
            }
          },
          startAt: 1790,
          sourceName: 'piggyCoin',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '050a8fda-b10c-4791-8680-fc1a1aef50f7',
          type: 'Tween',
          name: 'rewardIcon_tweenScale_1_copy_copy_copy',
          duration: 75,
          track: 13,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1862,
          sourceName: 'rewardIcon',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'e8b55a1d-ce5d-42c3-83f6-18be09fffa82',
          type: 'Tween',
          name: 'piggyCoin_tweenScale_1_copy_copy_copy',
          duration: 75,
          track: 11,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1862,
          sourceName: 'piggyCoin',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '5804794d-0a20-420c-903d-64559af9e09e',
          type: 'Tween',
          name: 'impact_alphaTween_3',
          duration: 50,
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 1864,
          sourceName: 'impact',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'c0d9b1f3-baa6-457c-8dc6-0825e1d1aeae',
          type: 'Tween',
          name: 'piggyCoin_tweenPos_7',
          duration: 250,
          track: 5,
          target: {
            y: -120
          },
          startAt: 1865,
          sourceName: 'piggyCoin',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '6d9f1abd-b886-44cf-ba9d-c76fcdecae70',
          type: 'Setter',
          name: 'impact_setAlpha_3',
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 1866,
          sourceName: 'impact',
          disabled: false
        },
        {
          id: 'd8ff2a8a-dac1-4458-ae6d-f6e21a483f3e',
          type: 'Tween',
          name: 'piggyCoin_tweenAlpha_1',
          duration: 200,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 2037,
          sourceName: 'piggyCoin',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class WinScreenRewardsLayout {
  static raw = raw;
  root!: Container;
  partContainer!: Container;
  wrapper!: Container;
  rays!: Sprite;
  circleGlow!: Sprite;
  rewardIcon!: Sprite;
  piggyBankSlot!: Container;
  rewardAmountText!: Text;
  piggyBankContainer!: Container;
  particleStartPoint!: Container;
  oldAmountContainer!: Container;
  fullText!: Text;
  impact!: Sprite;
  piggyCoin!: Sprite;
  oldRewardAmountText!: Text;
  oldRewardCrossed!: Graphics;
  upperCase_SPL!: (Text)[];
  StateName!: 'coin' | 'piggyBank' | 'piggyBankFull';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Rewards_Animation {
  Layout: {
    rays: object;
  };

  BlockTypeByName: {
    ResetAngle: object;
    raysRotation: object;
  };

  flowData = raw.animations[0];
}

export abstract class Appear {
  Layout: {
    partContainer: object;
    wrapper: object;
  };

  BlockTypeByName: {
    FXPART_End_Game_Behind_Rewards_Particles: object;
    Wrapper: object;
    WrapperScale: object;
  };

  flowData = raw.animations[1];
}

export abstract class Show_Old_Amount {
  Layout: {
    oldAmountContainer: object;
    oldRewardCrossed: object;
    rewardAmountText: object;
  };

  BlockTypeByName: {
    containerAlphaSetter: object;
    crossedFade: object;
    containerMoveAndFade: object;
    increaseAmountSize: object;
    containerMoveFadeOut: object;
  };

  flowData = raw.animations[2];
}

export abstract class PiggyBank_Full {
  Layout: {
    rewardAmountText: object;
    fullText: object;
    piggyCoin: object;
    rewardIcon: object;
    impact: object;
  };

  BlockTypeByName: {
    rewardText_scaleTween_1: object;
    rewardText_scaleTween_0: object;
    fullText_scaleTween_0: object;
    fullText_pos_Tween_0: object;
    fullText_pos_Tween_1: object;
    piggyCoin_setAlpha: object;
    piggyCoin_tweenPos_0: object;
    fullText_pos_Tween_2: object;
    piggyCoin_tweenScale_0: object;
    rewardIcon_tweenScale_0: object;
    impact_alphaTween_0: object;
    rewardIcon_tweenScale_1: object;
    piggyCoin_tweenScale_1: object;
    impact_setAlpha_0: object;
    piggyCoin_tweenPos_1: object;
    fullText_pos_Tween_3: object;
    fullText_pos_Tween_4: object;
    piggyCoin_tweenPos_2: object;
    piggyCoin_tweenScale_0_copy: object;
    rewardIcon_tweenScale_0_copy: object;
    piggyCoin_tweenScale_1_copy: object;
    rewardIcon_tweenScale_1_copy: object;
    impact_alphaTween_1: object;
    impact_setAlpha_1: object;
    piggyCoin_tweenPos_3: object;
    piggyCoin_tweenPos_4: object;
    piggyCoin_tweenScale_0_copy_copy: object;
    rewardIcon_tweenScale_0_copy_copy: object;
    piggyCoin_tweenScale_1_copy_copy: object;
    rewardIcon_tweenScale_1_copy_copy: object;
    impact_alphaTween_2: object;
    impact_setAlpha_2: object;
    piggyCoin_tweenPos_5: object;
    piggyCoin_tweenPos_6: object;
    rewardIcon_tweenScale_0_copy_copy_copy: object;
    piggyCoin_tweenScale_0_copy_copy_copy: object;
    rewardIcon_tweenScale_1_copy_copy_copy: object;
    piggyCoin_tweenScale_1_copy_copy_copy: object;
    impact_alphaTween_3: object;
    piggyCoin_tweenPos_7: object;
    impact_setAlpha_3: object;
    piggyCoin_tweenAlpha_1: object;
  };

  flowData = raw.animations[3];
}
